export const correctionsTranslations = {
  ru: {
    'corrections.page.title': 'История ручных корректировок',
    'corrections.page.subtitle': 'Журнал операторских исправлений с аудитом before/after; отмена не удаляет историю',
    'corrections.filter.statusAria': 'Фильтр по статусу',
    'corrections.filter.typeAria': 'Фильтр по типу',
    'corrections.filter.allStatuses': 'Все статусы',
    'corrections.filter.allTypes': 'Все типы',
    'corrections.filter.status.applied': 'Применена',
    'corrections.filter.status.cancelled': 'Отменена',
    'corrections.filter.status.draft': 'Черновик',
    'corrections.filter.targetEntityType': 'Target entity type',
    'corrections.filter.targetEntityId': 'Target entity ID',
    'corrections.filter.bankTransactionId': 'Bank transaction ID',
    'corrections.column.id': 'ID',
    'corrections.column.targetType': 'Цель (тип)',
    'corrections.column.targetId': 'Цель (ID)',
    'corrections.column.bankTx': 'Транзакция',
    'corrections.column.appliedCreated': 'Применена / создана',
    'corrections.column.cancelled': 'Отменена',
    'corrections.empty.title': 'Ручных корректировок пока нет',
    'corrections.empty.description': 'Записи появятся после операторских исправлений с обязательной причиной.',
    'corrections.detail.notFound': 'Корректировка не найдена',
    'corrections.detail.title': 'Корректировка {id}…',
    'corrections.detail.cancel': 'Отменить корректировку',
    'corrections.detail.summary': 'Сводка',
    'corrections.detail.organization': 'Организация',
    'corrections.detail.location': 'Локация',
    'corrections.detail.correctionType': 'Тип корректировки',
    'corrections.detail.targetEntity': 'Целевая сущность',
    'corrections.detail.bankImport': 'Импорт выписки',
    'corrections.detail.bankTransaction': 'Банковская транзакция',
    'corrections.detail.match': 'Сопоставление',
    'corrections.detail.allocation': 'Распределение',
    'corrections.detail.rowVersion': 'Row version',
    'corrections.detail.created': 'Создана',
    'corrections.detail.applied': 'Применена',
    'corrections.detail.cancelledAt': 'Отменена',
    'corrections.detail.cancelReason': 'Причина отмены',
    'corrections.cancel.title': 'Отмена корректировки',
    'corrections.cancel.description': 'Отмена помечает запись как cancelled и пишет audit. Исходные бизнес-сущности автоматически не откатываются.',
    'corrections.cancel.reasonPlaceholder': 'Причина отмены (обязательно)',
    'corrections.cancel.reasonHint': 'Причина обязательна, минимум 10 символов. Не вставляйте пароли, токены, API keys или raw credentials.',
    'corrections.cancel.confirm': 'Подтвердить отмену',
    'corrections.cancel.close': 'Закрыть',
    'corrections.cancel.reasonInvalid': 'Проверьте причину отмены.',
    'corrections.cancel.concurrencyError': 'Данные изменились. Обновите страницу и повторите отмену.',
    'corrections.cancel.transitionError': 'Корректировка уже не может быть отменена.',
    'corrections.cancel.forbidden': 'Недостаточно прав для отмены корректировки.',
    'corrections.cancel.error': 'Не удалось отменить корректировку.',
    'corrections.json.sensitiveWarning': 'В payload могут быть чувствительные поля — не копируйте наружу без проверки.',
    'corrections.json.before': 'Before JSON',
    'corrections.json.after': 'After JSON',
    'corrections.json.metadata': 'Metadata JSON',
  },
  en: {
    'corrections.page.title': 'Manual corrections history',
    'corrections.page.subtitle': 'Operator correction journal with before/after audit; cancellation does not delete history',
    'corrections.filter.statusAria': 'Filter by status',
    'corrections.filter.typeAria': 'Filter by type',
    'corrections.filter.allStatuses': 'All statuses',
    'corrections.filter.allTypes': 'All types',
    'corrections.filter.status.applied': 'Applied',
    'corrections.filter.status.cancelled': 'Cancelled',
    'corrections.filter.status.draft': 'Draft',
    'corrections.filter.targetEntityType': 'Target entity type',
    'corrections.filter.targetEntityId': 'Target entity ID',
    'corrections.filter.bankTransactionId': 'Bank transaction ID',
    'corrections.column.id': 'ID',
    'corrections.column.targetType': 'Target (type)',
    'corrections.column.targetId': 'Target (ID)',
    'corrections.column.bankTx': 'Transaction',
    'corrections.column.appliedCreated': 'Applied / created',
    'corrections.column.cancelled': 'Cancelled',
    'corrections.empty.title': 'No manual corrections yet',
    'corrections.empty.description': 'Records appear after operator corrections with a required reason.',
    'corrections.detail.notFound': 'Correction not found',
    'corrections.detail.title': 'Correction {id}…',
    'corrections.detail.cancel': 'Cancel correction',
    'corrections.detail.summary': 'Summary',
    'corrections.detail.organization': 'Organization',
    'corrections.detail.location': 'Location',
    'corrections.detail.correctionType': 'Correction type',
    'corrections.detail.targetEntity': 'Target entity',
    'corrections.detail.bankImport': 'Statement import',
    'corrections.detail.bankTransaction': 'Bank transaction',
    'corrections.detail.match': 'Match',
    'corrections.detail.allocation': 'Allocation',
    'corrections.detail.rowVersion': 'Row version',
    'corrections.detail.created': 'Created',
    'corrections.detail.applied': 'Applied',
    'corrections.detail.cancelledAt': 'Cancelled',
    'corrections.detail.cancelReason': 'Cancellation reason',
    'corrections.cancel.title': 'Cancel correction',
    'corrections.cancel.description': 'Cancellation marks the record as cancelled and writes audit. Original business entities are not automatically rolled back.',
    'corrections.cancel.reasonPlaceholder': 'Cancellation reason (required)',
    'corrections.cancel.reasonHint': 'Reason is required, minimum 10 characters. Do not paste passwords, tokens, API keys, or raw credentials.',
    'corrections.cancel.confirm': 'Confirm cancellation',
    'corrections.cancel.close': 'Close',
    'corrections.cancel.reasonInvalid': 'Check the cancellation reason.',
    'corrections.cancel.concurrencyError': 'Data changed. Refresh the page and retry cancellation.',
    'corrections.cancel.transitionError': 'Correction can no longer be cancelled.',
    'corrections.cancel.forbidden': 'Insufficient permissions to cancel correction.',
    'corrections.cancel.error': 'Failed to cancel correction.',
    'corrections.json.sensitiveWarning': 'Payload may contain sensitive fields — do not copy externally without review.',
    'corrections.json.before': 'Before JSON',
    'corrections.json.after': 'After JSON',
    'corrections.json.metadata': 'Metadata JSON',
  },
  id: {
    'corrections.page.title': 'Riwayat koreksi manual',
    'corrections.page.subtitle': 'Jurnal koreksi operator dengan audit before/after; pembatalan tidak menghapus riwayat',
    'corrections.filter.statusAria': 'Filter berdasarkan status',
    'corrections.filter.typeAria': 'Filter berdasarkan tipe',
    'corrections.filter.allStatuses': 'Semua status',
    'corrections.filter.allTypes': 'Semua tipe',
    'corrections.filter.status.applied': 'Diterapkan',
    'corrections.filter.status.cancelled': 'Dibatalkan',
    'corrections.filter.status.draft': 'Draf',
    'corrections.filter.targetEntityType': 'Target entity type',
    'corrections.filter.targetEntityId': 'Target entity ID',
    'corrections.filter.bankTransactionId': 'Bank transaction ID',
    'corrections.column.id': 'ID',
    'corrections.column.targetType': 'Target (tipe)',
    'corrections.column.targetId': 'Target (ID)',
    'corrections.column.bankTx': 'Transaksi',
    'corrections.column.appliedCreated': 'Diterapkan / dibuat',
    'corrections.column.cancelled': 'Dibatalkan',
    'corrections.empty.title': 'Belum ada koreksi manual',
    'corrections.empty.description': 'Catatan muncul setelah koreksi operator dengan alasan wajib.',
    'corrections.detail.notFound': 'Koreksi tidak ditemukan',
    'corrections.detail.title': 'Koreksi {id}…',
    'corrections.detail.cancel': 'Batalkan koreksi',
    'corrections.detail.summary': 'Ringkasan',
    'corrections.detail.organization': 'Organisasi',
    'corrections.detail.location': 'Lokasi',
    'corrections.detail.correctionType': 'Tipe koreksi',
    'corrections.detail.targetEntity': 'Entitas target',
    'corrections.detail.bankImport': 'Impor rekening koran',
    'corrections.detail.bankTransaction': 'Transaksi bank',
    'corrections.detail.match': 'Pencocokan',
    'corrections.detail.allocation': 'Alokasi',
    'corrections.detail.rowVersion': 'Row version',
    'corrections.detail.created': 'Dibuat',
    'corrections.detail.applied': 'Diterapkan',
    'corrections.detail.cancelledAt': 'Dibatalkan',
    'corrections.detail.cancelReason': 'Alasan pembatalan',
    'corrections.cancel.title': 'Batalkan koreksi',
    'corrections.cancel.description': 'Pembatalan menandai catatan sebagai cancelled dan menulis audit. Entitas bisnis asli tidak otomatis di-rollback.',
    'corrections.cancel.reasonPlaceholder': 'Alasan pembatalan (wajib)',
    'corrections.cancel.reasonHint': 'Alasan wajib, minimal 10 karakter. Jangan tempel password, token, API keys, atau raw credentials.',
    'corrections.cancel.confirm': 'Konfirmasi pembatalan',
    'corrections.cancel.close': 'Tutup',
    'corrections.cancel.reasonInvalid': 'Periksa alasan pembatalan.',
    'corrections.cancel.concurrencyError': 'Data berubah. Muat ulang halaman dan coba lagi.',
    'corrections.cancel.transitionError': 'Koreksi tidak dapat dibatalkan lagi.',
    'corrections.cancel.forbidden': 'Izin tidak cukup untuk membatalkan koreksi.',
    'corrections.cancel.error': 'Gagal membatalkan koreksi.',
    'corrections.json.sensitiveWarning': 'Payload mungkin berisi field sensitif — jangan salin ke luar tanpa pemeriksaan.',
    'corrections.json.before': 'Before JSON',
    'corrections.json.after': 'After JSON',
    'corrections.json.metadata': 'Metadata JSON',
  },
} as const;
